// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomLink__link--hch0g {
    transition: color 0.25s ease-in-out;
    color: var(--main-color);
}

    @media (hover: hover) and (pointer: fine) {
        .CustomLink__link--hch0g:hover, .CustomLink__link--hch0g:active {
            color: var(--secondary-color);
        }
    }
`, "",{"version":3,"sources":["webpack://./src/components/CustomLink/CustomLink.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,wBAAwB;AAO5B;;IALI;QACI;YACI,6BAA6B;QACjC;IACJ","sourcesContent":[".link {\n    transition: color 0.25s ease-in-out;\n    color: var(--main-color);\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover, &:active {\n            color: var(--secondary-color);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `CustomLink__link--hch0g`
};
export default ___CSS_LOADER_EXPORT___;
